import * as React from 'react';
import PropTypes from 'prop-types';
import { styles } from '../TextInput/TextInput.style';

const TextArea = ({
  className = '',
  invalid = false,
  placeholder = '',
  ...inputAttributes
}) => {
  return (
    <div>
      <textarea
        css={styles.defaultInput({ $invalid: invalid })}
        className={className}
        placeholder={placeholder}
        {...inputAttributes}
      />
    </div>
  );
};

TextArea.propTypes = {
  /** ClassName is supported such that styled components can pass extra styling.
   * Do not use this to adjust the styling, because the ordering of the applied tailwind classes is undeterministic */
  className: PropTypes.string,
  /** Set to invalid state */
  invalid: PropTypes.bool,
  /** Set to disabled state */
  disabled: PropTypes.bool,
  /** Fill in the placeholder */
  placeholder: PropTypes.string,
  onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};

export default TextArea;
